import { render } from "./ReferenteAmministrativoRead.vue?vue&type=template&id=111b0458"
import script from "./ReferenteAmministrativoRead.vue?vue&type=script&lang=js"
export * from "./ReferenteAmministrativoRead.vue?vue&type=script&lang=js"

import "./ReferenteAmministrativoRead.vue?vue&type=style&index=0&id=111b0458&lang=css"

import exportComponent from "/home/ubuntu/spark/spark-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__